module.exports = __webpack_public_path__ + "img/activate.b1ac2196.svg";